import type { Card, ReviewRecord, Sm2State } from './types.js';

const DAY_MS = 24 * 60 * 60 * 1000;

export function initialSm2State(): Sm2State {
  const now = Date.now();
  return {
    interval: 0,
    repetition: 0,
    ef: 2.5,
    nextReview: now,
  };
}

function clampEf(ef: number): number {
  return Math.max(1.3, ef);
}

/**
 * Apply a SM-2 style update for a rating on a 1–4 scale.
 * Maps rating to SM-2 quality: q = rating + 1 (range 2–5).
 */
export function applyReview(sm2: Sm2State, rating: number): Sm2State {
  const q = rating + 1;
  let ef = sm2.ef + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02));
  ef = clampEf(ef);

  let interval: number;
  let repetition: number;

  if (q < 3) {
    // Failed recall: reset
    repetition = 0;
    interval = 1;
  } else {
    repetition = sm2.repetition + 1;
    if (repetition === 1) {
      interval = 1;
    } else if (repetition === 2) {
      interval = 3;
    } else {
      interval = Math.max(1, Math.round(sm2.interval * ef));
    }
  }

  const nextReview = Date.now() + interval * DAY_MS;
  return { interval, repetition, ef, nextReview };
}

export function getDueCards(cards: Card[], now = Date.now()): Card[] {
  return cards.filter((card) => card.sm2.nextReview <= now);
}

export function createReviewRecord(cardId: string, rating: number): ReviewRecord {
  return { cardId, rating, reviewedAt: Date.now() };
}
